window.dataLayer = window.dataLayer || []
const { cartCurrency, template } = document.querySelector('body').dataset

/**
 * ----------------------------------
 * Form events
 * ----------------------------------
 */
addGaFormEventListeners()

function addGaFormEventListeners () {
  document.querySelectorAll('[data-ga-el="form"]').forEach(form => {
    form.addEventListener('submit', e => {
      window.dataLayer.push({
        event: e.currentTarget.dataset.gaEvent,
        formSubmit: {
          form_name: e.currentTarget.dataset.gaName,
          submit_state: 'Successful',
        },
      })
    })
  })
}

const loginFormSubmitEl = document.querySelector('[data-ga-el="loginFormSubmit"]')
if (loginFormSubmitEl) {
  loginFormSubmitEl.addEventListener('click', () => {
    sessionStorage.setItem('loginFormSubmitted', 'true')
  })
}

if (template === 'account') {
  const isLoginReferal = sessionStorage.getItem('loginFormSubmitted')

  if (isLoginReferal) {
    sessionStorage.removeItem('loginFormSubmitted')

    window.dataLayer.push({
      event: 'login_account_submission',
      formSubmit: {
        form_name: 'login_account_form',
        submit_state: 'Successful',
      },
    })
  }
}

window.addEventListener('GA_ADD_TO_CART', event => {
  const { formName, item, index } = event.detail

  if (!formName || !item) return

  window.dataLayer.push({
    event: 'add_to_cart_form',
    dlv: {
      target_context: formName,
      target_index: index || null,
      item_id: item.product_id,
      item_title: item.title,
      item_handle: item.handle,
      item_variant: item.variant_title,
      item_price: item.price % 1 !== 0 ? item.price / 100 : item.price,
      item_discounted: item.discounted_price % 1 !== 0 ? item.discounted_price / 100 : item.discounted_price,
    },
  })
})

/**
 * ----------------------------------
 * Header events
 * ----------------------------------
 */

/**
 * @description: Tracks Site Header Wishlist Link Interaction
 */
if (document.querySelector('[data-ga-el="headerWishlistLink"]')) {
  document.querySelector('[data-ga-el="headerWishlistLink"]').addEventListener('click', e => {
    window.dataLayer.push({
      event: 'header_wishlist_click',
    })
  })
}

/**
 * @description: Tracks Site Header Account Link Interaction
 */
const accountLinkEls = document.querySelectorAll('[data-ga-el="accountLink"]')
if (accountLinkEls.length > 0) {
  accountLinkEls.forEach(element => {
    element.addEventListener('click', event => {
      window.dataLayer.push({
        event: 'header_account_click',
      })
    })
  })
}

/**
 * @description: Top Nav Link Click
 */
const topNavLinkEls = document.querySelectorAll('[data-ga-el="desktopNavLink"]')
topNavLinkEls.forEach(linkEl => {
  linkEl.addEventListener('click', event => {
    const linkAnchorEl = event.target.closest('[data-ga-el="desktopNavLink"]')

    const linkType = linkAnchorEl.dataset.gaNavLinkType
    const linkIndex = linkAnchorEl.dataset.gaNavLinkIndex
    const navParent = linkAnchorEl.dataset.gaNavParent
    const clickUrl = linkAnchorEl.dataset.gaClickUrl
    const clickText = linkAnchorEl.dataset.gaClickText

    window.dataLayer.push({
      event: 'desktop_nav_link_click',
      desktopNavLinkClick: {
        nav_link_type: linkType,
        nav_link_index: linkIndex,
        nav_parent: navParent,
        click_url: clickUrl,
        click_text: clickText,
      },
    })
  })
})

/**
 * @description: Nav Link Click Mobile
 */
const mobileNavLinkEls = document.querySelectorAll('[data-ga-el="mobileNavLink"]')
mobileNavLinkEls.forEach(linkEl => {
  linkEl.addEventListener('click', event => {
    const linkAnchorEl = event.target.closest('[data-ga-el="mobileNavLink"]')

    const linkType = linkAnchorEl.dataset.gaNavLinkType
    const linkIndex = linkAnchorEl.dataset.gaNavLinkIndex
    const navParent = linkAnchorEl.dataset.gaNavParent
    const clickUrl = linkAnchorEl.dataset.gaClickUrl
    const clickText = linkAnchorEl.dataset.gaClickText

    window.dataLayer.push({
      event: 'mobile_nav_link_click',
      mobileNavLinkClick: {
        nav_link_type: linkType,
        nav_link_index: linkIndex,
        nav_parent: navParent,
        click_url: clickUrl,
        click_text: clickText,
      },
    })
  })
})

/**
 * @description: Mobile Nav Trigger Click
 */
const mobileNavDrawerTriggers = document.querySelectorAll('[data-ga-el="mobile-nav-toggle"]')
mobileNavDrawerTriggers.forEach(trigerEl => {
  trigerEl.addEventListener('click', event => {
    const trigerAnchorEl = event.target.closest('[data-ga-el="mobile-nav-toggle"]')
    const clickAction = trigerAnchorEl.dataset.gaClickAction

    window.dataLayer.push({
      event: 'mobile_nav_trigger_click',
      mobileNavTriggerClick: {
        click_action: clickAction,
      },
    })
  })
})

/**
 * @description: Quick search
 */
const searchInputEls = document.querySelectorAll('[data-ga-el="searchInput"]')
if (searchInputEls.length > 0) {
  searchInputEls.forEach(inputEl => {
    inputEl.addEventListener('click', () => {
      watchForFindifyAutocompleteWrapper()
    })
  })
}

function watchForFindifyAutocompleteWrapper () {
  const observerConfig = {
    childList: true,
    subtree: true,
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        const findifyContainer = document.querySelector('[data-findify-autocomplete-wrapper="true"]')

        if (findifyContainer) {
          findifyContainer.addEventListener('click', e => {
            pushSearchSuggestionEvent(e.target)
          })
          observer.disconnect()
        }
      }
    })
  })

  observer.observe(document.body, observerConfig)
}

function pushSearchSuggestionEvent (target) {
  const selectorClass = '.findify-components-autocomplete'
  const activeInput = [...searchInputEls].filter(input => input.value.length > 0)

  let clickAction = ''
  if (target.closest(`${selectorClass}--tip__wrapper`)) {
    clickAction = 'view_all'
  } else if (target.closest(`${selectorClass}--suggestions`)) {
    clickAction = 'suggestions'
  } else if (target.closest(`${selectorClass}--content`)) {
    clickAction = 'categories'
  }

  if (clickAction === '') return

  window.dataLayer.push({
    event: 'search_suggestion_click',
    searchSuggestionClick: {
      term: activeInput[0].value,
      click_action: clickAction,
      click_url: target.href || '',
      click_text: target.innerText || '',
    },
  })
}

/**
 * @description: Product Card Carousel
 */

if (document.querySelector('[data-ga-el="imageSlide"]')) {
  document.querySelectorAll('[data-ga-el="imageSlide"]').forEach(slide => {
    let isThrottled = false
    const throttleInterval = 2000 // Throttle interval in milliseconds

    slide.addEventListener('touchmove', (event) => {
      if (!isThrottled) {
        const currentTarget = event.currentTarget
        const productName = currentTarget.dataset.gaVariableProduct
        const slideIndex = currentTarget.dataset.gaElIndex + 1

        // Run your callback function here
        window.dataLayer.push({
          event: 'gallery_image_swipe_plp',
          productCardSwipe: {
            product_name: productName,
            slide_index: slideIndex,
          },
        })

        // Set throttled state
        isThrottled = true

        // Schedule next execution
        setTimeout(() => {
          isThrottled = false
        }, throttleInterval)
      }
    })
  })
}

/**
 * ----------------------------------
 * Footer events
 * ----------------------------------
 */

/**
 * @description: Footer Click
 */
const footerLinks = document.querySelectorAll('[data-ga-el="footerMenuLink"]')
if (footerLinks.length > 0) {
  footerLinks.forEach(footerLink => {
    footerLink.addEventListener('click', e => {
      const clickText = e.currentTarget.dataset.gaFooterLinkText
      const clickUrl = e.currentTarget.dataset.gaFooterLinkUrl
      const navParent = e.currentTarget.dataset.gaFooterLinkParent

      window.dataLayer.push({
        event: 'footer_link_click',
        footerLinkClick: {
          nav_parent: navParent,
          click_url: clickUrl,
          click_text: clickText,
        },
      })
    })
  })
}

/**
 * ----------------------------------
 * PLP scoped events
 * ----------------------------------
 */

if (template.includes('collection')) {
  /**
   * @description: PLP Select Size
   */
  if (document.querySelector('[data-ga-size-el="plpSizeClick"]')) {
    document.querySelectorAll('[data-ga-size-el="plpSizeClick"]').forEach(input => {
      input.addEventListener('click', event => {
        window.dataLayer.push({
          event: 'plp_size_click',
          plpSize: {
            size_availability: event.target.dataset.gaVariableAvailable,
            product_name: event.target.dataset.gaVariableProduct,
            size_selected: event.target.dataset.gaVariableSize,
          },
        })
      })
    })
  }

  /**
   * @description: PLP sub-collection link click
   */
  const subCollectionLinkEls = document.querySelectorAll('[data-ga-el="subCollectionLink"]')
  if (subCollectionLinkEls.length) {
    subCollectionLinkEls.forEach(linkEl => {
      linkEl.addEventListener('click', event => {
        window.dataLayer.push({
          event: 'plp_quick_links',
          dlv: {
            target_text: event.currentTarget.innerText,
          },
        })
      })
    })
  }

  /**
   * @description: Paginated PLP click
   */
  const paginationEls = document.querySelectorAll('[data-ga-el="pagination"]')
  if (paginationEls.length > 0) {
    paginationEls.forEach(el => {
      el.addEventListener('click', event => {
        const { gaPage, gaAction, gaCollection, gaPageSize } = event.target.dataset

        window.dataLayer.push({
          event: 'paginated_plp_click',
          paginatedPLPClick: {
            current_page: gaPage,
            click_action: gaAction,
            item_list_name: gaCollection,
            page_size: gaPageSize,
          },
        })
      })
    })
  }
}

/**
 * ----------------------------------
 * PDP scoped events
 * ----------------------------------
 */
if (template.includes('product')) {
  /**
   * @description: PDP Select Size
   */
  if (document.querySelector('[data-ga-el="pdpSizeClick"]')) {
    document.querySelectorAll('[data-ga-el="pdpSizeClick"]').forEach(input => {
      input.addEventListener('click', e => {
        window.dataLayer.push({
          event: 'pdp_size_click',
          pdpSize: {
            size_availability: e.currentTarget.dataset.gaVariableAvailable,
            product_name: e.currentTarget.dataset.gaVariableProduct,
            size_selected: e.currentTarget.dataset.gaVariableSize,
          },
        })
      })
    })
  }

  /**
   * @description: PDP Carousel
   */
  if (document.querySelector('[data-ga-el="imageSlidePDP"]')) {
    document.querySelectorAll('[data-ga-el="imageSlidePDP"]').forEach(slide => {
      let isThrottled = false
      const throttleInterval = 2000 // Throttle interval in milliseconds

      slide.addEventListener('touchmove', (event) => {
        if (!isThrottled) {
          // Run your callback function here
          const currentTarget = event.currentTarget
          const productName = currentTarget.dataset.gaVariableProduct
          const slideIndex = currentTarget.dataset.gaElIndex + 1

          window.dataLayer.push({
            event: 'gallery_image_swipe_pdp',
            pdpGallerySwipe: {
              product_name: productName,
              slide_index: slideIndex,
            },
          })

          // Set throttled state
          isThrottled = true

          // Schedule next execution
          setTimeout(() => {
            isThrottled = false
          }, throttleInterval)
        }
      })
    })
  }

  /**
   * @description: Globo Back In Stock
   */

  // Watch for the Globo modal trigger to load, then add event listener
  (function () {
    const observerConfig = {
      childList: true,
      subtree: true,
    }

    const observer = new MutationObserver((mutations) => {
      let eventAdded = false

      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const globoWrapper = document.querySelector('#Globo-Back-In-Stock')

          if (globoWrapper) {
            const globoModalTrigger = globoWrapper.querySelector('.gBackInStockBtn')

            if (globoModalTrigger && !eventAdded) {
              handleNotifyMeOpen(globoModalTrigger)

              eventAdded = true
              observer.disconnect()
            }
          }
        }
      })
    })

    observer.observe(document, observerConfig)
  })()

  function handleNotifyMeOpen (notifyMeTriggerEl) {
    notifyMeTriggerEl.addEventListener('click', event => {
      watchForGloboModal()

      const product = window.Globo?.Preorder.settings.product
      const { handle, id, title, price } = product

      const variantInputs = [...document.querySelectorAll('[data-ga-el="pdpSizeClick"]')]
      const hasVariants = variantInputs.length > 0
      const selectedVariant = hasVariants ? variantInputs.filter(input => input.checked)[0] : product.variants[0]
      const selectedVariantId = hasVariants ? selectedVariant?.dataset.variantId : selectedVariant?.id
      const selectedVariantTitle = hasVariants ? selectedVariant?.value : selectedVariant?.title

      window.dataLayer.push({
        event: 'notify_me_open_pdp',
        notifyMeOpenPdp: {
          item: {
            product_handle: handle,
            product_id: id,
            product_title: title,
            variant_title: selectedVariantTitle,
            variant_id: selectedVariantId,
            price: price / 100,
          },
        },
      })
    })
  }

  // Watch for the Globo modal trigger to load, then add event listener
  function watchForGloboModal () {
    const observerConfig = {
      childList: true,
      subtree: true,
    }

    const observer = new MutationObserver((mutations) => {
      let eventAdded = false

      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const globoModalWrapper = document.querySelector('#Globo-Back-In-Stock-Popup')

          if (globoModalWrapper) {
            const globoSubmitButton = globoModalWrapper.querySelector('.Globo-content-button')

            if (globoSubmitButton && !eventAdded) {
              handleNotifyMeSubmit(globoSubmitButton)

              eventAdded = true
              observer.disconnect()
            }
          }
        }
      })
    })

    observer.observe(document, observerConfig)
  }

  function handleNotifyMeSubmit (globoSubmitButton) {
    globoSubmitButton.addEventListener('click', event => {
      const eventName = 'notify_me_submit_pdp'
      const eventIsPushed = window.dataLayer?.filter(obj => obj.event === eventName).length > 0

      if (eventIsPushed) return

      const product = window.Globo?.Preorder.settings.product
      const { handle, id, title, price } = product

      const variantInputs = [...document.querySelectorAll('[data-ga-el="pdpSizeClick"]')]
      const hasVariants = variantInputs.length > 0
      const selectedVariant = hasVariants ? variantInputs.filter(input => input.checked)[0] : product.variants[0]
      const selectedVariantId = hasVariants ? selectedVariant?.dataset.variantId : selectedVariant?.id
      const selectedVariantTitle = hasVariants ? selectedVariant?.value : selectedVariant?.title

      window.dataLayer.push({
        event: eventName,
        notifyMeSubmitPdp: {
          item: {
            product_handle: handle,
            product_id: id,
            product_title: title,
            variant_title: selectedVariantTitle,
            variant_id: selectedVariantId,
            price: price / 100,
          },
        },
      })
    })
  }

  /**
   * @description: PDP accordion Click
   */
  const accordionEls = document.querySelectorAll('[data-ga-el="pdpDetailsAccordion"]')
  if (accordionEls.length > 0) {
    accordionEls.forEach(accordionEl => {
      accordionEl.addEventListener('click', e => {
        const clickedAccordion = e.target.closest('[data-ga-el="pdpDetailsAccordion"]')
        const isExpanded = clickedAccordion.getAttribute('aria-expanded') === 'false'
        const clickTitle = clickedAccordion.dataset.gaVariableTitle
        const clickAction = isExpanded ? 'open' : 'close'

        window.dataLayer.push({
          event: 'pdp_accordion',
          pdpAccordion: {
            accordion_name: clickTitle || '',
            click_action: clickAction,
          },
        })
      })
    })
  }

  /**
   * @description: Product details description - 'Style With' click
   */
  const productDetailsDescriptionEl = document.querySelector('[data-ga-el="productDetailsDescription"]')
  if (productDetailsDescriptionEl) {
    productDetailsDescriptionEl.addEventListener('click', e => {
      const el = e.target

      if (!el.href) return

      const clickUrl = el.href
      const clickText = el.innerText || ''
      const productName = el.closest('[data-ga-product-title]')

      window.dataLayer.push({
        event: 'pdp_styled_with_click',
        pdpStyledWithClick: {
          click_url: clickUrl,
          click_text: clickText,
          product_name: productName.dataset.gaProductTitle,
        },
      })
    })
  }

  /**
   * @description: Size Guide Fit PDP
   */
  const sizeGuideEl = document.querySelector('[data-ga-el="sizeGuidePopup"]')
  if (sizeGuideEl) {
    sizeGuideEl.addEventListener('click', event => {
      window.dataLayer.push({
        event: 'pdp_size_guide_click',
        pdpSizeGuideClick: {
          item: event.target.dataset?.gaProduct,
        },
      })
    })
  }

  /**
   * @description: Concierge Interaction
   */
  const conciergeEl = document.querySelector('[data-ga-el="concierge"]')
  if (conciergeEl) {
    conciergeEl.addEventListener('click', event => {
      window.dataLayer.push({
        event: 'pdp_concierge_click',
        pdpConciergeClick: {
          item: event.target.dataset?.gaProduct,
        },
      })
    })
  }
}

/**
 * ----------------------------------
 * Minicart events
 * ----------------------------------
 */
/**
 * @description: Mini Cart Recs click
 */
function handleMiniCartRecsClick () {
  const miniCartRecommendationLinkEls = document.querySelectorAll('[data-ga-el="miniCartRecommendations"] [data-ga-el="productCardLink"]')

  miniCartRecommendationLinkEls.forEach(linkEl => {
    linkEl.addEventListener('click', event => {
      const productCardEl = event.target.closest('[data-ga-el="product-card"]')
      const productHandle = productCardEl.dataset.gaProductHandle
      const placementName = productCardEl.dataset.gaPlacement
      const itemIndex = productCardEl.dataset.gaIndex

      pushProductCardClickEvent(placementName, productHandle, itemIndex)
    })
  })
}

/**
 * @description: Mini Cart open/close
 */
window.document.addEventListener('fostrOffCanvasMenuEvent', (event) => {
  const { menuHTMLObject, action } = event.detail

  if (menuHTMLObject.id !== 'mini-cart') return

  if (action === 'open') {
    handleMiniCartRecsClick()

    let origin = ''
    switch (event.detail.origin) {
      case 'cart-items':
        origin = 'product-add'
        break
      case 'offcanvas-menu':
        origin = 'trigger-click'
        break
    }

    window.dataLayer.push({
      event: 'minicart_popup_open_event',
      minicartOpen: {
        open_method: origin,
      },
    })
  } else if (action === 'close') {
    window.dataLayer.push({
      event: 'minicart_popup_close_event',
    })
  }
})

/**
 * @description: Track empty mincart recommendations click
 */
const emptyMinicartRecsSlide = document.querySelectorAll('[data-ga-el="emptyMinicartRecs"]')
if (emptyMinicartRecsSlide.length > 0) {
  emptyMinicartRecsSlide.forEach(slide => {
    slide.addEventListener('click', event => {
      const slideEl = event.target.closest('[data-ga-el="emptyMinicartRecs"]')
      const { gaItem, gaType, gaIndex } = slideEl.dataset

      window.dataLayer.push({
        event: 'empty_minicart_recs_click',
        emptyMinicartRecClick: {
          item: gaItem,
          type: gaType,
          index: gaIndex,
        },
      })
    })
  })
}

/**
 * @description: Track mincart concierge form submit
 */
const conciergeFormSubmitEl = document.querySelector('[data-ga-el="minicart-concierge-submit"]')
if (conciergeFormSubmitEl) {
  conciergeFormSubmitEl.addEventListener('click', () => {
    window.dataLayer.push({
      event: 'minicart_concierge_submit',
    })
  })
}

/**
 * ----------------------------------
 * Other events
 * ----------------------------------
 */

/**
 * @description: Nosto elements
 */
const nostoElements = document.querySelectorAll('.nosto_element')
if (nostoElements.length) {
  [...nostoElements].forEach(element => {
    const observer = new MutationObserver((mutations, observer) => {
      addListenersToNostoSection(mutations[0].target)
      observer.disconnect()
    })

    observer.observe(element, { childList: true, subtree: true })
  })
}

function addListenersToNostoSection (element) {
  const carouselEl = element.querySelector('slider-component')

  if (carouselEl) {
    carouselEl.addEventListener('click', trackNostoRecsCarousels)
  }

  // const nostoProductCards = document.querySelectorAll(
  //   '.nosto_element product-card',
  // )
  // if (nostoProductCards.length) {
  //   nostoProductCards.forEach(el => {
  //     el.addEventListener('click', trackProductCardClick)
  //   })
  // }
}

function trackNostoRecsCarousels (event) {
  const target = event.target
  const targetContext = target.closest('[data-gtm-target-context]')

  if (!targetContext) return

  const isArrowClick = target.closest('.slider-buttons')
  const isProductCardClick = target.closest('a.nosto-prod-info') || target.closest('a.img-container')
  const isAddToCart = target.closest('.nosto-atc-outer')

  let eventAction = ''
  if (isArrowClick) {
    eventAction = 'Arrow click'
  } else if (isProductCardClick) {
    eventAction = 'Product card click'
  } else if (isAddToCart) {
    eventAction = 'Add to cart'
  } else {
    eventAction = 'Drag'
  }

  window.dataLayer.push({
    event: 'nosto_recs_interaction',
    dlv: {
      target_context: targetContext.dataset.gtmTargetContext,
      event_action: eventAction,
    },
  })
}

/**
 * @description: Product Card Click
 */
function handleProductCardClick () {
  const productCardLinkEls = document.querySelectorAll('[data-ga-el="productCardLink"]')

  productCardLinkEls.forEach(linkEl => {
    linkEl.addEventListener('click', event => {
      const productCardEl = event.target.closest('[data-ga-el="product-card"]')
      const productHandle = productCardEl.dataset.gaProductHandle
      const placementName = productCardEl.dataset.gaPlacement
      const itemIndex = productCardEl.dataset.gaIndex

      pushProductCardClickEvent(placementName, productHandle, itemIndex)
    })
  })
}

handleProductCardClick()

window.addEventListener('MINICART_RECOMMENDATIONS_RENDERED', event => {
  handleProductCardClick()
})

function pushProductCardClickEvent (placementName, productHandle, itemIndex) {
  fetch(`${window.Shopify.routes.root}products/${productHandle}.js`)
    .then(response => response.json())
    .then(product => {
      window.dataLayer.push({
        event: 'product_card_click',
        productCardClick: {
          placement_name: placementName,
          item_index: itemIndex,
          item: {
            product_id: product.id,
            title: product.title,
            handle: product.handle,
            price: product.price / 100,
            discounted_price: product.compare_at_price,
            in_stock: product.available,
          },
        },
      })
    })
}

/**
 * @description: Colour swatch click
 */
window.addEventListener('GA_SWATCHES_LOADED', (event) => {
  const swatchesEl = event.detail.swatchesEl
  const swatchEls = swatchesEl?.querySelectorAll('[data-ga-el="colourSwatch"]')

  if (!swatchEls.length) return

  swatchEls.forEach(swatchEl => {
    swatchEl.addEventListener('click', event => {
      window.dataLayer.push({
        event: 'colour_swatch_click',
        dlv: {
          target_text: event.currentTarget.dataset.gaColourSelected,
        },
      })
    })
  })
})

/**
 * @description: Add to wishlist
 */
window.addEventListener('WISHLIST_ADD_PRODUCT', event => {
  const productId = event.detail.productId
  const productTitle = event.detail.productTitle
  const productPrice = event.detail.productPrice

  window.dataLayer.push({
    event: 'add_to_wishlist',
    ecommerce: {
      currency: cartCurrency,
      value: parseInt(productPrice),
      items: [
        {
          item_id: productId,
          item_name: productTitle,
        },
      ],
    },
  })
})

/**
 * @description: Remove from wishlist
 */
window.addEventListener('WISHLIST_REMOVE_PRODUCT', event => {
  const productId = event.detail.productId
  const productTitle = event.detail.productTitle
  const productPrice = event.detail.productPrice

  window.dataLayer.push({
    event: 'remove_from_wishlist',
    dlv: {
      item_value: parseInt(productPrice),
      item_id: productId,
      item_title: productTitle,
    },
  })
})

/**
 * @description: Add to wishlist abort
 */
const closeWishlistModalEl = document.querySelector("[data-ga-el='wishlistAbort']")
if (closeWishlistModalEl) {
  closeWishlistModalEl.addEventListener('click', (event) => {
    const action = event.target.closest('[data-ga-action]').dataset.gaAction

    window.dataLayer.push({
      event: 'add_to_wishlist_abort',
      addToWishlistAbort: {
        action,
      },
    })
  })
}

/**
 * @description: Homepage click
 */
if (template && template === 'index') {
  const sections = document.querySelectorAll('#MainContent .shopify-section')

  sections.forEach(section => {
    section.addEventListener('click', event => {
      const target = event.target
      const clickedLinkEl = target.closest('a[href]')

      if (!clickedLinkEl) return

      const sectionWrapperEl = target.closest('#MainContent .shopify-section')
      const sectionOffsets = [...sections].map(section => section.offsetTop)
      const sectionIndex = sectionOffsets.indexOf(sectionWrapperEl.offsetTop)
      const sectionName = [...sectionWrapperEl.classList].filter(className => className !== 'shopify-section')

      window.dataLayer.push({
        event: 'homepage_section_click',
        dlv: {
          target_index: `${sectionIndex + 1}`,
          target_context: sectionName.length ? sectionName[0] : 'shopify-section',
          target_url: clickedLinkEl.href,
        },
      })
    })
  })
}
